import { motion } from 'framer-motion';
import { ExternalLink } from 'lucide-react';
import { NIC_PORTRAIT, fadeUp, fadeIn } from './data';

const AWARDS = [
  "Gold Award — 2019, 2023, 2024, 2025",
  "Top 100 — 2022, 2024, 2025",
  "Regional Category Winner — 2022",
];

export const BuilderSection = () => (
  <section className="py-20 md:py-28 bg-[#3d4f3c]" data-testid="builder-section">
    <div className="max-w-6xl mx-auto px-6 md:px-12">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
        <motion.div {...fadeIn} className="order-2 lg:order-1">
          <div className="aspect-[4/5] overflow-hidden">
            <img src={NIC_PORTRAIT} alt="Nic Foster — Founder, NF Construction" className="w-full h-full object-cover" />
          </div>
          <p className="mt-5 text-[#d6cdb4] text-xs tracking-[0.2em] uppercase text-center lg:text-left">Nic Foster — Founder</p>
        </motion.div>

        <motion.div {...fadeUp} className="order-1 lg:order-2">
          <p className="text-[#d6cdb4] text-sm tracking-[0.25em] uppercase mb-6">The Builder</p>
          <h2 className="text-3xl md:text-4xl text-white font-light mb-8">Built by NF Construction</h2>
          <div className="text-white/85 text-base md:text-lg leading-relaxed space-y-5 mb-8">
            <p>
              NF Construction is the builder of The 126 House, working from the architectural design
              by Wingates. Founder Nic Foster leads a hands-on team focused on craftsmanship and detail.
            </p>
            <p>NF's homes have been recognised in the Registered Master Builders House of the Year awards since the company's first Gold Award in 2019:</p>
          </div>
          <ul className="space-y-3 mb-10 border-l border-[#d6cdb4]/50 pl-5" data-testid="builder-awards">
            {AWARDS.map((a) => <li key={a} className="text-white text-sm md:text-base">{a}</li>)}
          </ul>
          <a
            href="https://www.nfconstruction.co.nz"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="visit-nf-link"
            className="inline-flex items-center gap-2 text-[#d6cdb4] text-sm tracking-[0.12em] uppercase border-b border-[#d6cdb4]/60 pb-1 hover:text-white hover:border-white transition-colors"
          >
            Visit NF Construction
            <ExternalLink size={14} />
          </a>
        </motion.div>
      </div>
    </div>
  </section>
);
